import React from "react";
import { FileType } from "../../interfaces/others/ILegacyDocument";
import ExpedienteDocumentRow, {
  ExpedienteDocumentExpandedBody,
} from "./ExpedienteDocumentRow.tsx";

const LegacyDocItem = ({
  legacyDoc,
  obligatory,
  onEditClick,
  isLoading = false,
  isLast = false,
  animationDelay = 0,
}: {
  legacyDoc: FileType;
  obligatory: boolean;
  onEditClick?: () => void;
  isLoading?: boolean;
  isLast?: boolean;
  animationDelay?: number;
}) => {
  const [expanded, setExpanded] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (isLoading) {
      setExpanded(false);
    }
  }, [isLoading]);

  const fileCount = legacyDoc.files?.length || 0;

  const formatDate = (date: string | null) => {
    if (!date) return "";
    const newDate = new Date(date);
    return `${newDate.getDate()}/${
      newDate.getMonth() + 1
    }/${newDate.getFullYear()}`;
  };

  const getLatestDate = () => {
    if (!legacyDoc.files || legacyDoc.files.length === 0) return null;
    const dates = legacyDoc.files
      .map((file: any) => file.lastModified)
      .filter(Boolean)
      .map((date: string) => new Date(date).getTime());

    if (dates.length === 0) return null;
    const latestTimestamp = Math.max(...dates);
    return new Date(latestTimestamp).toISOString();
  };

  const latestDate = getLatestDate();
  const hasFiles = fileCount > 0;

  const metaText =
    !isLoading && hasFiles
      ? `${fileCount} archivo${fileCount !== 1 ? "s" : ""}${
          latestDate ? ` · ${formatDate(latestDate)}` : ""
        }`
      : null;

  return (
    <ExpedienteDocumentRow
      title={legacyDoc.typeFile}
      obligatory={obligatory}
      metaText={metaText}
      isMetaLoading={isLoading}
      hasFiles={hasFiles}
      expanded={expanded}
      onToggleExpand={() => setExpanded(!expanded)}
      isLast={isLast}
      animationDelay={animationDelay}
      expandedContent={
        <ExpedienteDocumentExpandedBody
          count={fileCount}
          lastUpdated={latestDate}
          formattedDate={(d) => formatDate(d)}
          onEdit={() => onEditClick?.()}
        />
      }
    />
  );
};

export default LegacyDocItem;
